import * as angular from 'angular';
import template from './notificationComment.tpl.html';

export interface NotificationCommentData {
  title: string;
}

export function openNotificationComment(data: NotificationCommentData,
                                        $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'NotificationCommentCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

class NotificationCommentCtrl {
  form: any;
  comment: string;
  title: string;
  $modalInstance: mm.foundation.modalInstance;

  constructor($modalInstance: mm.foundation.modalInstance,
              data: NotificationCommentData) {
    this.$modalInstance = $modalInstance;
    if (data) {
      this.title = data.title;
    }
  }

  submit(): void {
    if (this.form.$invalid) {
      return;
    }

    this.$modalInstance.close(this.comment);
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.notificationComment', [])
  .controller('NotificationCommentCtrl', NotificationCommentCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/notifications/notificationComment.controller.ts